import { observer } from 'mobx-react';
import { FC } from 'react';
import { CustomerTypeEnum } from 'app/types/customer';
import logoTradeUp from 'static/images/logo_tradeup.png';
import UI from 'stores/ui';
import { isEmptyValue } from 'utils/helper';
import styles from './style.scss';

const customerTypeConfig: Record<CustomerTypeEnum, string> = {
    [CustomerTypeEnum.INDIVIDUAL]: __('Individual Account'),
    [CustomerTypeEnum.IRA_ROLLOVER]: __('Rollover IRA'),
    [CustomerTypeEnum.IRA_ROTH]: __('Roth IRA'),
    [CustomerTypeEnum.IRA_TRADITIONAL]: __('Traditional IRA')
};

const Logo: FC = () => {
    const { showLogo, logoCustomerType } = UI;

    return showLogo ? (
        <header className={styles.header}>
            <img src={logoTradeUp} className={styles.logo} alt="TradeUP" />
            {/* customerType可能为0 */}
            {isEmptyValue(logoCustomerType) ? null : (
                <span className={styles.category}>{customerTypeConfig[logoCustomerType!]}</span>
            )}
        </header>
    ) : null;
};

export default observer(Logo);
export * from './hooks';
